

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { EventManager } from './EventManager.js';
import LazyBackgroundImage from './LazyBackgroundImage.vue';

export default {
    data() {
        return {
          pageReady: false,
          isChangingSlides: false,
          currentIndex: 0,
          contentBoxOffset: 1,

          swiperOptions: {
            pagination: {
              el: '.'+this.sliderId+' .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            effect: 'slide',
            autoplay: {delay: 5000},
            speed: 1000,
            grabCursor: true,
            autoHeight: false,
            keyboard: true,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            runCallbacksOnInit: true,
            navigation: {
              nextEl: '.home-slider .swiper-button-next',
              prevEl: '.home-slider .swiper-button-prev',
            },
          },
        };
    },

    props: {
      sliderData: Array,
      showPagination: {
        type: Boolean,
        default: true,
      },
      showNavigation: {
        type: Boolean,
        default: true,
      },
      sliderId: {
        type: String,
        default: function() {
          // If not set, generate a unique id
          var S4 = function() {
             return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
          };
          return 'slider-'+(S4()+S4()+'-'+S4()+'-'+S4()+'-'+S4()+'-'+S4()+S4()+S4());
        },
      },
    },

    computed: {
      slider() {
        return this.$refs.slider.swiper;
      },
      currentSlide: function(){
        return (this.currentIndex < this.sliderData.length) ? this.sliderData[this.currentIndex] : null;
      },
    },

    watch: {

    },

    methods: {
      onSwiperSlideChangeTransitionStart: function() {
        this.isChangingSlides = true;
      },
      onSwiperSlideChangeTransitionEnd: function() {
        this.isChangingSlides = false;
        this.currentIndex = this.slider.realIndex;
      },
    },

    components: {
      swiper,
      swiperSlide,
      LazyBackgroundImage,
    },

    created() {

    },

    destroyed () {

    },

    mounted() {

      var self = this;

      setTimeout(function() {
        // Triggering an update after 0.5s to make sure the views are properly spaced according to
        // the current window size. This shouldn't really be necessary but occasionally I have found
        // the rendering is slightly off until the window is resized, so just making sure.
        self.slider.update();
      }, 500);

    },
};




// WEBPACK FOOTER //
// ./scripts/vue/HomeSlider.vue